import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
// import Swiper from 'swiper';
import * as actions from '../../redux/actions';
import logoHeader from '../../assets/img/logo.svg';

const Header = () => {
  const { body } = document;
  // const width = body.offsetWidth;
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const listLanguage = useSelector(
    (state) => state.languageReducer.list_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [pageScaleBar, setPageScaleBar] = useState(0);

  const [searchField, setSearchField] = useState('');

  useEffect(() => {
    if (dictionary) {
      if (dictionary[location.pathname.split('/').pop()] !== undefined) {
        document.title = `${dictionary.president_title} | ${dictionary[location.pathname.split('/').pop()]}`;
      }
      if (dictionary[location.pathname.split('/').pop()] === undefined
      && dictionary[location.pathname.split('/')[location.pathname.split('/').length - 2]]) {
        document.title = `${dictionary.president_title} | ${dictionary[location.pathname.split('/')[location.pathname.split('/').length - 2]]}`;
      }
      if (location.pathname.includes('page=')
      && !location.pathname.includes('search')) {
        document.title = `${dictionary.president_title} | ${dictionary[location.pathname.split('/')[location.pathname.split('/').length - 2]]}`;
      }

      if (location.pathname.includes('search') || (location.pathname.includes('search')
      && location.pathname.includes('page='))) {
        document.title = dictionary.search;
      }
      if (location.pathname === '/') { document.title = `${dictionary.president_title} | ${dictionary.main}`; }
    }
  }, [location.pathname, dictionary]);

  const searchPress = (e) => {
    if (e.charCode === 13 && searchField) {
      navigate(`/search/?q=${searchField}`);
      setSearchField('');

      const selectMobileSearch = document.querySelector('.search-advanced');
      if (selectMobileSearch && selectMobileSearch.classList.contains('show')) {
        selectMobileSearch.classList.remove('show');
      }
    }
  };

  const handleSearch = (e) => {
    const searchText = e.target.value;
    setSearchField(searchText);
  };

  // Показ меню
  const showMenu = () => {
    const burger = document.querySelector('.burger');
    const language = document.querySelector('.header-footer__language');
    const languageContainer = document.querySelector('.language-container');
    const sizeTextAll = document.querySelectorAll('.size-text');
    const menu = document.querySelector('.header-footer');
    const close = document.querySelector('.header-footer__close');
    const itemsList = document.querySelector('.header-footer__container');

    burger.addEventListener('click', () => {
      menu.classList.add('show');
      body.classList.add('menu-show');
    });

    close.addEventListener('click', () => {
      body.classList.remove('menu-show');
      menu.classList.remove('show');
      language.classList.remove('show');
      languageContainer.removeAttribute('style');
      sizeTextAll.forEach((sizeText) => {
        sizeText.classList.remove('show');
      });
    });

    itemsList.addEventListener('click', () => {
      if (menu.classList.contains('show')) {
        body.classList.remove('menu-show');
        menu.classList.remove('show');
        language.classList.remove('show');
        languageContainer.removeAttribute('style');
        sizeTextAll.forEach((sizeText) => {
          sizeText.classList.remove('show');
        });
      }
    });
  };

  // Очистить поле поиска в мобильной версии
  const clearMobileSearchField = () => {
    const clearSearch = document.querySelector('.search-advanced-close');

    clearSearch.addEventListener('click', () => {
      setSearchField('');
    });
  };

  // Выбор языка
  const language = () => {
    const languageBox = document.querySelector('.language');
    const listAll = languageBox.querySelectorAll('li');

    listAll.forEach((list) => {
      list.addEventListener('click', () => {
        listAll.forEach((elem) => {
          elem.classList.remove('active');
        });
        list.classList.add('active');
      });
    });
  };

  // Выбор языка в мобильной версии
  const languageMob = () => {
    const language = document.querySelector('.header-footer__language');
    const title = language.querySelector('.language-title');
    const listAll = language.querySelectorAll('.language-list');

    language.addEventListener('click', (e) => {
      let { target } = e;
      const container = language.querySelector('.language-container');
      const content = language.querySelector('.language-content');

      if (target.closest('.language-box')) {
        if (!language.classList.contains('show')) {
          language.classList.add('show');
          container.style.cssText = `
            height: ${content.clientHeight}px;
          `;
        } else {
          language.classList.remove('show');
          container.removeAttribute('style');
        }
      }

      if (target.closest('.language-list')) {
        listAll.forEach((elem) => {
          elem.classList.remove('active');
        });

        target = target.closest('.language-list');
        target.classList.add('active');
        title.textContent = target.innerText;
        language.classList.remove('show');
        container.removeAttribute('style');
      }
    });
  };

  // Показ range
  const rangeShow = () => {
    const rangeBoxAll = document.querySelectorAll('.size-text');

    rangeBoxAll.forEach((rangeBox) => {
      rangeBox.addEventListener('click', (e) => {
        const { target } = e;

        if (target.closest('svg')) {
          rangeBox.classList.toggle('show');
        }
      });
    });
  };

  // Плавный скролл до якоря
  const anchors = () => {
    const anchors = document.querySelectorAll('a[href*="#"]');

    for (const anchor of anchors) {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();

        const blockID = anchor.getAttribute('href').substr(1);

        document.getElementById(blockID).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    }
  };

  // Показ поиска на мобильном
  const showSearch = () => {
    const search = document.querySelector('.search-advanced');
    body.addEventListener('click', (e) => {
      const { target } = e;

      if (target.closest('.search-mob')) {
        search.classList.add('show');
      }

      if (target.closest('.search-advanced__close')) {
        search.classList.remove('show');
      }
    });
  };

  // Select в форме
  const selectShow = () => {
    const selectAll = document.querySelectorAll('.select');

    selectAll.forEach((select) => {
      if (select) {
        select.addEventListener('click', (e) => {
          let { target } = e;
          const container = select.querySelector('.select-container');
          const box = select.querySelector('.select-box');
          const title = select.querySelector('.select-title__text');

          if (target.closest('.select-title')) {
            if (!select.classList.contains('show')) {
              select.classList.add('show');
              container.style.cssText = `
                height: ${box.clientHeight}px;
              `;
            } else {
              select.classList.remove('show');
              container.removeAttribute('style');
            }
          }

          if (target.closest('.select-box li')) {
            target = target.closest('.select-box li');
            title.textContent = target.textContent;
            container.removeAttribute('style');
            select.classList.remove('show');
          }
        });
      }
    });
  };

  // Слайдер
  // const eventsSwiper = () => {
  //   const swiper = new Swiper('.events-swiper', {
  //     spaceBetween: 2,
  //     slidesPerView: 7,
  //     freeMode: true,
  //     watchSlidesProgress: true,
  //     breakpoints: {
  //       // when window width is >= 320px
  //       320: {
  //         slidesPerView: 3,
  //       },
  //       // when window width is >= 576px
  //       576: {
  //         slidesPerView: 4,
  //       },
  //       // when window width is >= 768px
  //       768: {
  //         slidesPerView: 5,
  //       },
  //       // when window width is >= 992px
  //       992: {
  //         slidesPerView: 5,
  //       },
  //       // when window width is >= 1200px
  //       1200: {
  //         slidesPerView: 6,
  //       },
  //       // when window width is >= 12400px
  //       1400: {
  //         slidesPerView: 7,
  //       },
  //     },
  //   });
  //   const swiper2 = new Swiper('.events-swiper2', {
  //     spaceBetween: 10,
  //     navigation: {
  //       nextEl: '.events-swiper2-next',
  //       prevEl: '.events-swiper2-prev',
  //     },
  //     thumbs: {
  //       swiper,
  //     },
  //   });
  // };

  // Все события на главнрй
  const eventAllShow = () => {
    body.addEventListener('click', (e) => {
      const container = document.querySelector('.main-tab-container');
      const box = document.querySelector('.main-tab-box');
      let { target } = e;

      if (target.closest('#main-tab-all')) {
        target = target.closest('#main-tab-all');

        if (!target.classList.contains('show')) {
          container.style.cssText = `
          height: ${box.clientHeight}px;
          `;
          target.classList.add('show');
          target.textContent = 'Пинҳон';
        } else {
          container.removeAttribute('style');
          target.classList.remove('show');
          target.textContent = 'Хамаи рӯйдодҳо';
        }
      }
    });
  };

  // Показ табов
  const showTab = () => {
    const box = document.querySelector('.tabs-box');

    if (box) {
      const tabs = box.querySelector('.nav-tabs');
      const arrow = box.querySelector('.tabs-arrow');
      const tabsItem = tabs.querySelectorAll('.nav-item');
      const arrowStyle = window.getComputedStyle(arrow);
      const displayArrow = arrowStyle.getPropertyValue('display');

      if (tabsItem.length > 0 && displayArrow === 'flex') {
        box.style.cssText = `
        height: ${tabsItem[0].clientHeight}px;
        `;
      }

      if (tabsItem.length <= 3) {
        arrow.style.cssText = `
          display: none;
        `;
        tabs.style.cssText = `
          padding-right: 0px;
        `;
      }

      box.addEventListener('click', (e) => {
        let { target } = e;

        if (target.closest('.tabs-arrow')) {
          e.stopImmediatePropagation();
          target = target.closest('.tabs-arrow');

          if (!target.classList.contains('show')) {
            target.classList.add('show');
            box.style.cssText = `
            height: ${tabs.clientHeight}px;
            `;
          } else {
            target.classList.remove('show');
            box.removeAttribute('style');

            if (tabsItem.length > 0) {
              box.style.cssText = `
              height: ${tabsItem[0].clientHeight}px;
              `;
            }
          }
        }

        if (target.closest('.nav-item')
        && arrow.classList.contains('show')) {
          arrow.classList.remove('show');
        }
      });
    }
  };

  const handleKeyPress = () => {};

  // useEffect(() => {
  //   if (typeof currentLanguage != 'undefined') {
  //   }
  // }, [currentLanguage, listLanguage]);

  const changeLange = (language) => {
    dispatch(actions.setCurrentLanguage(language));

    const html = document.querySelector('html');

    html.setAttribute('lang', language.name);
    html.setAttribute('dir', '');

    if (language.name === 'ae') {
      html.setAttribute('dir', 'rtl');
    }
  };

  const showLang = () => listLanguage.map((value) => {
    if (value.name === currentLanguage.name) {
      return (
        <li
          key={value.id}
          onKeyDown={handleKeyPress}
          role="presentation"
          onClick={() => changeLange(value)}
          className="active"
        >
          <span>{value.fullname}</span>
        </li>
      );
    }
    return (
      <li
        key={value.id}
        onKeyDown={handleKeyPress}
        role="presentation"
        onClick={() => changeLange(value)}
      >
        <span>{value.fullname}</span>
      </li>
    );
  });

  const showLangMobile = () => listLanguage.map((value) => {
    if (value.name === currentLanguage.name) {
      return (
        <span
          key={value.id}
          onKeyDown={handleKeyPress}
          role="presentation"
          onClick={() => changeLange(value)}
          className="language-list active"
        >
          <span>{value.fullname}</span>
        </span>
      );
    }
    return (
      <span
        key={value.id}
        onKeyDown={handleKeyPress}
        role="presentation"
        onClick={() => changeLange(value)}
        className="language-list"
      >
        <span>{value.fullname}</span>
      </span>
    );
  });

  const ranger = (idBox, idRange) => {
    const rangeBox = document.getElementById(idBox);
    const range = document.querySelector(idRange);

    const percent = (elem) => {
      let percent;
      switch (+elem) {
        case 24:
          percent = 0;
          break;
        case 25:
          percent = 12.5;
          break;
        case 26:
          percent = 25;
          break;
        case 27:
          percent = 37.5;
          break;
        case 28:
          percent = 50;
          break;
        case 29:
          percent = 62.5;
          break;
        case 30:
          percent = 75;
          break;
        case 31:
          percent = 87.5;
          break;
        case 32:
          percent = 100;
          break;
        default:
          percent = 0;
          break;
      }

      if (document.dir === 'rtl') {
        range.style.cssText = `
        background: linear-gradient(270deg, rgb(59, 107, 59) ${percent}%, rgb(226, 226, 226) ${percent}%)
        `;
      } else {
        range.style.cssText = `
        background: linear-gradient(90deg, rgb(59, 107, 59) ${percent}%, rgb(226, 226, 226) ${percent}%)
        `;
      }
    };

    rangeBox.addEventListener('input', (e) => {
      const { target } = e;
      if (target.closest(idRange)) {
        const valueRange = range.value;
        percent(valueRange);
        setPageScaleBar(valueRange);
        localStorage.setItem('font_size', valueRange);
        dispatch(actions.adjustFontSize(valueRange));
      }
    });
  };

  const handleChange = () => {
    dispatch(actions.setFontSize(localStorage.getItem('font_size')));
  };

  useEffect(() => {
    anchors();
    showMenu();
    language();
    languageMob();
    rangeShow();
    ranger('rangeBox', '#range');
    ranger('rangeBox2', '#range2');
    showSearch();
    selectShow();
    // eventsSwiper();
    eventAllShow();
    showTab();
    clearMobileSearchField();

    if (fontSize !== undefined) {
      setPageScaleBar(fontSize);

      let percent;
      switch (+fontSize) {
        case 24:
          percent = 0;
          break;
        case 25:
          percent = 12.5;
          break;
        case 26:
          percent = 25;
          break;
        case 27:
          percent = 37.5;
          break;
        case 28:
          percent = 50;
          break;
        case 29:
          percent = 62.5;
          break;
        case 30:
          percent = 75;
          break;
        case 31:
          percent = 87.5;
          break;
        case 32:
          percent = 100;
          break;
        default:
          percent = 0;
          break;
      }

      if (document.dir === 'rtl') {
        document.querySelector('#range').style.cssText = `
        background: linear-gradient(270deg, rgb(59, 107, 59) ${percent}%, rgb(226, 226, 226) ${percent}%)
        `;
        document.querySelector('#range2').style.cssText = `
        background: linear-gradient(270deg, rgb(59, 107, 59) ${percent}%, rgb(226, 226, 226) ${percent}%)
        `;
      } else {
        document.querySelector('#range').style.cssText = `
        background: linear-gradient(90deg, rgb(59, 107, 59) ${percent}%, rgb(226, 226, 226) ${percent}%)
        `;
        document.querySelector('#range2').style.cssText = `
        background: linear-gradient(90deg, rgb(59, 107, 59) ${percent}%, rgb(226, 226, 226) ${percent}%)
        `;
      }
    }
  }, []);

  useEffect(() => {
    showTab();
    dispatch(actions.adjustFontSize(fontSize));
    clearMobileSearchField();
  }, [location]);

  return (
    <header className="header">
      <div className="search-advanced">
        <div className="container">
          <div className="search-advanced__head">
            <div className="search-advanced__button">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 15V17H7V15H1ZM1 3V5H11V3H1ZM11 19V17H19V15H11V13H9V19H11ZM5 7V9H1V11H5V13H7V7H5ZM19 11V9H9V11H19ZM13 7H15V5H19V3H15V1H13V7Z"
                  fill="#3B6B3B"
                />
              </svg>
              <span>{dictionary.search}</span>
            </div>
            <div className="search-advanced__close">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 2.01429L17.9857 0L10 7.98571L2.01429 0L0 2.01429L7.98571 10L0 17.9857L2.01429 20L10 12.0143L17.9857 20L20 17.9857L12.0143 10L20 2.01429Z"
                  fill="#AAAAAA"
                />
              </svg>
            </div>
          </div>
          <div className="search-advanced__container">
            <input
              value={searchField}
              onKeyPress={searchPress}
              onChange={handleSearch}
              type="text"
              placeholder={dictionary.search}
            />
            <div className="search-advanced-button">
              <button type="button">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z"
                    fill="#AAAAAA"
                  />
                </svg>
              </button>
            </div>
            <div className="search-advanced-close">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 2.01429L17.9857 0L10 7.98571L2.01429 0L0 2.01429L7.98571 10L0 17.9857L2.01429 20L10 12.0143L17.9857 20L20 17.9857L12.0143 10L20 2.01429Z"
                  fill="#AAAAAA"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="header-head">
        <div className="container">
          <div className="header-head__container">
            <div className="logo-container">
              <div className="burger d-lg-none">
                <svg
                  width="20"
                  height="12"
                  viewBox="0 0 20 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 12H20V10H0V12ZM0 7H20V5H0V7ZM0 0V2H20V0H0Z"
                    fill="#222222"
                  />
                </svg>
              </div>

              <div
                className="logo"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/');
                }}
                onKeyDown={handleKeyPress}
                role="button"
                tabIndex="0"
                aria-label="logo"
              >
                <div className="logo-img">
                  <img src={logoHeader} alt="" />
                </div>
                <a href="/" className="logo-text">
                  <span>{dictionary.president_text_1.toUpperCase()}</span>
                  <span>{dictionary.president_text_2.toUpperCase()}</span>
                </a>
              </div>
            </div>

            <div className="search-mob d-lg-none">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z"
                  fill="#222222"
                />
              </svg>
            </div>

            <div className="header-head__box d-none d-lg-flex">
              <ul className="language">
                {typeof listLanguage !== 'undefined' && listLanguage.length > 0
                  ? showLang()
                  : null}
              </ul>

              <div className="size-text">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.28393 17.0283H3.22489L2.71326 19H1.15338L3.68662 10.2023H4.92204L7.46775 19H5.82052L5.28393 17.0283ZM3.56183 15.7305H5.00939L4.51023 13.6964L4.31057 12.3237H4.26065L4.04851 13.7089L3.56183 15.7305ZM17.0426 15.3853H13.2677L12.3297 19H9.46995L14.1142 2.8709H16.3792L21.0463 19H18.0264L17.0426 15.3853ZM13.8854 13.0059H16.5393L15.6242 9.27678L15.2581 6.76019H15.1666L14.7777 9.29966L13.8854 13.0059Z"
                    fill="#333333"
                  />
                </svg>
                <div className="size-text__box">
                  <span>{dictionary.text}</span>
                  <div id="rangeBox" className="size-text__range">
                    <div className="range__slide">
                      <input
                        onChange={handleChange}
                        id="range"
                        type="range"
                        min="24"
                        max="32"
                        step="1"
                        className="range"
                        value={pageScaleBar}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="social">
                <a href="https://www.facebook.com/emomalirahmontjk">
                  <svg
                    className="social-facebook"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 0.54541C5.67413 0.54541 0.54541 5.67413 0.54541 12C0.54541 17.7164 4.73362 22.4545 10.2106 23.3171V15.3118H7.30084V12H10.2106V9.47629C10.2106 6.60319 11.9209 5.01887 14.5363 5.01887C15.7895 5.01887 17.1024 5.24225 17.1024 5.24225V8.05921H15.6544C14.2338 8.05921 13.7894 8.94359 13.7894 9.84974V11.9977H16.9637L16.4563 15.3095H13.7894V23.3148C19.2663 22.4568 23.4545 17.7175 23.4545 12C23.4545 5.67413 18.3258 0.54541 12 0.54541Z" />
                  </svg>
                </a>
                <a href="https://www.instagram.com/emomalirahmontjk">
                  <svg
                    className="social-svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.0006" cy="12.0001" r="11.4542" />
                    <path d="M18.8333 9.17852C18.8256 8.60018 18.7174 8.02758 18.5134 7.48635C18.3365 7.02982 18.0663 6.61522 17.7201 6.26902C17.3739 5.92282 16.9593 5.65265 16.5028 5.47575C15.9685 5.2752 15.4041 5.16675 14.8335 5.15504C14.0989 5.1222 13.866 5.11304 12.0013 5.11304C10.1365 5.11304 9.89753 5.11304 9.16828 5.15504C8.59798 5.16684 8.03381 5.27528 7.49978 5.47575C7.04318 5.65252 6.62851 5.92265 6.2823 6.26887C5.93608 6.61508 5.66595 7.02975 5.48918 7.48635C5.28822 8.02022 5.18001 8.58451 5.16923 9.15485C5.13639 9.89021 5.12646 10.1231 5.12646 11.9879C5.12646 13.8526 5.12646 14.0908 5.16923 14.8209C5.18068 15.392 5.28835 15.9556 5.48918 16.4909C5.66625 16.9473 5.93658 17.3619 6.28291 17.7079C6.62924 18.054 7.04395 18.324 7.50054 18.5007C8.03311 18.7093 8.59738 18.8255 9.16904 18.8443C9.9044 18.8772 10.1373 18.8871 12.002 18.8871C13.8668 18.8871 14.1058 18.8871 14.8351 18.8443C15.4056 18.8331 15.9701 18.7249 16.5043 18.5244C16.9607 18.3473 17.3752 18.0771 17.7214 17.7309C18.0676 17.3847 18.3378 16.9702 18.5149 16.5138C18.7157 15.9793 18.8234 15.4157 18.8349 14.8438C18.8677 14.1092 18.8776 13.8763 18.8776 12.0108C18.8761 10.146 18.8761 9.9093 18.8333 9.17852ZM11.9967 15.5142C10.0464 15.5142 8.46651 13.9343 8.46651 11.984C8.46651 10.0338 10.0464 8.45385 11.9967 8.45385C12.933 8.45385 13.8309 8.82578 14.4929 9.48782C15.155 10.1499 15.5269 11.0478 15.5269 11.984C15.5269 12.9203 15.155 13.8182 14.4929 14.4803C13.8309 15.1423 12.933 15.5142 11.9967 15.5142ZM15.6674 9.14645C15.5593 9.14655 15.4522 9.12532 15.3523 9.08399C15.2523 9.04266 15.1616 8.98203 15.0851 8.90557C15.0086 8.82911 14.948 8.73832 14.9067 8.63841C14.8653 8.53849 14.8441 8.4314 14.8442 8.32327C14.8442 8.21522 14.8655 8.10823 14.9069 8.0084C14.9482 7.90858 15.0088 7.81787 15.0852 7.74147C15.1616 7.66506 15.2523 7.60446 15.3521 7.56311C15.452 7.52176 15.559 7.50048 15.667 7.50048C15.7751 7.50048 15.8821 7.52176 15.9819 7.56311C16.0817 7.60446 16.1724 7.66506 16.2488 7.74147C16.3252 7.81787 16.3858 7.90858 16.4272 8.0084C16.4685 8.10823 16.4898 8.21522 16.4898 8.32327C16.4898 8.77839 16.1217 9.14645 15.6674 9.14645Z" />
                    <path d="M11.9967 14.2772C13.2632 14.2772 14.2899 13.2505 14.2899 11.9841C14.2899 10.7176 13.2632 9.69092 11.9967 9.69092C10.7303 9.69092 9.70361 10.7176 9.70361 11.9841C9.70361 13.2505 10.7303 14.2772 11.9967 14.2772Z" />
                  </svg>
                </a>
                <a href="https://t.me/emomalirahmontjk">
                  <svg
                    className="social-facebook"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM17.88 7.32L15.84 17.16C15.72 17.88 15.24 18 14.76 17.64L11.64 15.24C10.92 15.96 10.2 16.56 10.08 16.8C9.84 16.92 9.72 17.16 9.48 17.16C9.12 17.16 9.12 16.92 9 16.68L7.92 13.08L4.68 12C3.96 11.76 3.96 11.28 4.8 10.92L17.04 6.24C17.52 6.12 18.12 6.36 17.88 7.32ZM15 8.4L8.16 12.72L9.24 16.32L9.48 13.92L15.36 8.64C15.72 8.28 15.48 8.28 15 8.4Z" />
                  </svg>
                </a>
                <a href="https://www.youtube.com/user/khadamotimatbuot">
                  <svg
                    className="social-svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="11.9997" cy="12" r="11.4553" />
                    <path d="M18.7146 8.64206C18.6348 8.34622 18.479 8.07642 18.2626 7.85952C18.0462 7.64263 17.7767 7.48619 17.4811 7.40578C16.3848 7.10476 11.999 7.09986 11.999 7.09986C11.999 7.09986 7.61394 7.09496 6.51697 7.38268C6.2215 7.46678 5.95261 7.62544 5.73611 7.8434C5.51962 8.06136 5.36279 8.33132 5.28069 8.62736C4.99157 9.72363 4.98877 11.9974 4.98877 11.9974C4.98877 11.9974 4.98597 14.2823 5.27299 15.3674C5.434 15.9673 5.90653 16.4413 6.50717 16.603C7.61464 16.904 11.9885 16.9089 11.9885 16.9089C11.9885 16.9089 16.3743 16.9138 17.4706 16.6268C17.7663 16.5465 18.036 16.3904 18.253 16.174C18.4699 15.9575 18.6266 15.6882 18.7076 15.3926C18.9974 14.297 18.9995 12.024 18.9995 12.024C18.9995 12.024 19.0135 9.73833 18.7146 8.64206ZM10.5961 14.1038L10.5996 9.90354L14.2448 12.0072L10.5961 14.1038Z" />
                  </svg>
                </a>
                <a href="https://x.com/emomalirahmontj">
                  <svg
                    className="social-svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.0006" cy="12.0001" r="11.4542" />
                    <path d="M17.831 8.94342C17.8409 9.07705 17.8409 9.20992 17.8409 9.34279C17.8409 13.409 14.746 18.0946 9.08993 18.0946C7.34736 18.0946 5.7285 17.5898 4.36621 16.7132C4.61362 16.7414 4.85187 16.7514 5.10921 16.7514C6.49363 16.7547 7.83886 16.2918 8.92804 15.4372C8.28616 15.4256 7.66394 15.2138 7.14824 14.8314C6.63254 14.4491 6.24912 13.9152 6.05151 13.3044C6.24165 13.3327 6.43255 13.3518 6.63262 13.3518C6.90828 13.3518 7.18547 13.3136 7.44281 13.2471C6.74621 13.1065 6.11983 12.7289 5.67017 12.1786C5.22051 11.6283 4.97534 10.9392 4.97634 10.2286V10.1904C5.3864 10.4187 5.86213 10.5615 6.36612 10.5806C5.94391 10.3 5.59771 9.91934 5.35841 9.47244C5.1191 9.02555 4.99414 8.52638 4.99467 8.01945C4.99467 7.44826 5.14662 6.92442 5.41313 6.46778C6.18601 7.4185 7.14997 8.19627 8.24257 8.75073C9.33518 9.30519 10.5321 9.62396 11.7557 9.68642C11.7084 9.45733 11.6793 9.21985 11.6793 8.9816C11.6791 8.57762 11.7586 8.17756 11.9131 7.80429C12.0676 7.43102 12.2941 7.09186 12.5798 6.80621C12.8654 6.52055 13.2046 6.29399 13.5779 6.13949C13.9511 5.98498 14.3512 5.90556 14.7552 5.90576C15.641 5.90576 16.4405 6.27688 17.0025 6.87708C17.6911 6.74392 18.3515 6.49254 18.9543 6.13408C18.7248 6.84487 18.244 7.44758 17.6019 7.82931C18.2127 7.75965 18.8095 7.59904 19.3728 7.35281C18.9521 7.96607 18.4309 8.50384 17.831 8.94342Z" />
                  </svg>
                </a>
                <a href="http://president.tj/rss-main">
                  <svg
                    className="social-svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.0006" cy="12.0001" r="11.4542" />
                    <path d="M16.1995 19C16.1995 12.8566 11.1434 7.80044 5 7.80044V5C12.679 5 19 11.321 19 19H16.1995ZM6.91844 15.1583C7.42823 15.1592 7.91688 15.3621 8.27736 15.7226C8.63783 16.0831 8.84076 16.5717 8.84168 17.0815C8.84168 18.139 7.97368 19 6.91406 19C5.85662 19 5 18.1408 5 17.0815C5 16.0224 5.86144 15.1583 6.91844 15.1583ZM14.2812 19H11.5582C11.5582 15.402 8.598 12.4397 5 12.4397V9.71888C10.0903 9.71888 14.2812 13.9092 14.2812 19Z" />
                  </svg>
                </a>
              </div>

              <div className="header-search">
                <input
                  type="text"
                  onKeyPress={searchPress}
                  onChange={handleSearch}
                  placeholder={dictionary.search}
                  value={searchField}
                />
                <div
                  className="header-search__button"
                  onClick={() => {
                    if (searchField) {
                      navigate(`/search/?q=${searchField}`);
                    }
                  }}
                  onKeyDown={handleKeyPress}
                  role="button"
                  tabIndex="0"
                  aria-label="calendar"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.9167 11.6667H12.2583L12.025 11.4417C12.8417 10.4917 13.3333 9.25833 13.3333 7.91667C13.3333 4.925 10.9083 2.5 7.91667 2.5C4.925 2.5 2.5 4.925 2.5 7.91667C2.5 10.9083 4.925 13.3333 7.91667 13.3333C9.25833 13.3333 10.4917 12.8417 11.4417 12.025L11.6667 12.2583V12.9167L15.8333 17.075L17.075 15.8333L12.9167 11.6667ZM7.91667 11.6667C5.84167 11.6667 4.16667 9.99167 4.16667 7.91667C4.16667 5.84167 5.84167 4.16667 7.91667 4.16667C9.99167 4.16667 11.6667 5.84167 11.6667 7.91667C11.6667 9.99167 9.99167 11.6667 7.91667 11.6667Z"
                      fill="#333333"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="header-footer">
        <div className="header-footer-mob d-lg-none">
          <div className="container">
            <div className="header-footer-mob__container">
              <div className="header-footer-mob__left">
                <div className="header-footer__close">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 2.01429L17.9857 0L10 7.98571L2.01429 0L0 2.01429L7.98571 10L0 17.9857L2.01429 20L10 12.0143L17.9857 20L20 17.9857L12.0143 10L20 2.01429Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="header-footer__language">
                  <div className="language-box">
                    <span className="language-title">{currentLanguage.fullname}</span>
                    <div className="language-icon">
                      <svg
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 1L6.5 6L1 1"
                          stroke="#222222"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="language-container">
                    <div className="language-content">
                      {typeof listLanguage !== 'undefined'
                      && listLanguage.length > 0
                        ? showLangMobile()
                        : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className="header-footer__size">
                <div className="size-text">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.28393 17.0283H3.22489L2.71326 19H1.15338L3.68662 10.2023H4.92204L7.46775 19H5.82052L5.28393 17.0283ZM3.56183 15.7305H5.00939L4.51023 13.6964L4.31057 12.3237H4.26065L4.04851 13.7089L3.56183 15.7305ZM17.0426 15.3853H13.2677L12.3297 19H9.46995L14.1142 2.8709H16.3792L21.0463 19H18.0264L17.0426 15.3853ZM13.8854 13.0059H16.5393L15.6242 9.27678L15.2581 6.76019H15.1666L14.7777 9.29966L13.8854 13.0059Z"
                      fill="#333333"
                    />
                  </svg>
                  <div className="size-text__box">
                    <span>{dictionary.text}</span>
                    <div id="rangeBox2" className="size-text__range">
                      <div className="range__slide">
                        <input
                          onChange={handleChange}
                          id="range2"
                          type="range"
                          min="24"
                          max="32"
                          step="1"
                          className="range"
                          value={pageScaleBar}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="header-footer__container">
            <div className="menu">
              <ul>
                <li>
                  <a
                    href="/tajikistan"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/tajikistan');
                    }}
                  >
                    {dictionary.tajikistan}
                  </a>
                </li>
                <li>
                  <a
                    href="/symbols"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/symbols');
                    }}
                  >
                    {dictionary.symbols}
                  </a>
                </li>
                <li>
                  <a
                    href="/leader_of_the_nation"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/leader_of_the_nation');
                    }}
                  >
                    {dictionary.leader_of_the_nation}
                  </a>
                </li>
                <li>
                  <a
                    href="/president"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/president');
                    }}
                  >
                    {dictionary.menus.menu_1}
                  </a>
                </li>
                <li>
                  <a
                    href="/government"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/government');
                    }}
                  >
                    {dictionary.government}
                  </a>
                </li>
                <li>
                  <a
                    href="/executive_office"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/executive_office');
                    }}
                  >
                    {dictionary.executive}
                  </a>
                </li>
              </ul>
            </div>
            <div className="header-footer__button">
              <button type="button" className="button" onClick={() => navigate('/contacts')}>
                {dictionary.contact_page.text_1}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
